import {
  createValidation,
  validatorRequired,
} from '../../utils/formValidators';
import { formTsAuctionBidFields } from '../../constants/forms/formTsAuctionBidFields';

export default createValidation([
  {
    name: formTsAuctionBidFields.UNIT_PRICE,
    validators: (field) => validatorRequired()(field),
  },
]);
